import React from "react";
import { useTranslation } from "react-i18next";
import { Tabs } from "antd";
import AssociatedEstimate from "./AssociatedEstimate";
import NotAssociatedEstimate from "./NotAssociatedEstimate";
import "./ProjectEstimate.css";

const ProjectEstimate = () => {
  const { t } = useTranslation();

  return (
    <>
      <Tabs
        className="PFtabs"
        defaultActiveKey="1"
        items={[
          {
            label: t("projectEstimate.tabs.associatedEstimate"),
            key: "1",
            children: <AssociatedEstimate />,
          },
          {
            label: t("projectEstimate.tabs.notAssociatedEstimate"),
            key: "2",
            children: <NotAssociatedEstimate />,
          },
        ]}
      />
    </>
  );
};

export default ProjectEstimate;
